module.exports = __webpack_public_path__ + "img/testimonial-11-61x61_1testimonial-11-61x61.7651d50c.png";